import { fetchApi } from "./fetchApi";

export default {
  async createTag(data) {
    const { serviceAreaId } = data;
    const response = await fetchApi({
      data,
      method: "POST",
      url: `/api/tag/sa/${serviceAreaId}`,
    });

    return response.data.result;
  },

  async delete(id: number, sa: number) {
    const response = await fetchApi({
      method: "DELETE",
      url: `/api/tag/${id}/sa/${sa}`,
    });

    return response.data.result;
  },

  async getTagById(id: number, sa: number) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/tag/${id}/sa/${sa}`,
    });

    return response.data.result;
  },

  async getReleaseNoteListByTagId(id: number, sa: number) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/tag/${id}/releaseNote/sa/${sa}`,
    });
    return response.data.result;
  },

  async list(sa: number) {
    const response = await fetchApi({
      method: "GET",
      url: `/api/tag/sa/${sa}`,
    });

    return response.data.result;
  },
  async update(data) {
    const { id, serviceAreaId } = data;
    const response = await fetchApi({
      method: "PUT",
      url: `/api/tag/${id}/sa/${serviceAreaId}`,
      data,
    });
    return response.data.result;
  },
};
